// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "loyalty__link-3q0HP";
export { _1 as "__esModule", _2 as "loyalty__link" }
export default { "__esModule": _1, "loyalty__link": _2 }
